import { s, ui } from '@owenscorning/pcb.alpha';
import _ from 'lodash';
import { useAttributeSet } from '../../../hooks/use_attribute_set';
import { constructField, deepResolveOfs } from './Types/AttributeSet';
import cms_api from '../../../cms_api';
import { filterEntity, isItemVisible } from '../../PageBuilder/helpers/content';

const constructChoicesFields = (basePath, baseLabel, filter) => {
  const thisFieldPath = [basePath, filter.field].filter(x => x).join('.');
  const thisLabelPath = [baseLabel, filter[filter.type].ofLabel].filter(x => x).join(': ');
  if (filter.type === 'choices') {
    const parameters = filter[filter.type]?.parameters || {};
    const component = {
      of: filter[filter.type].of,
      singular: [baseLabel, filter[filter.type].ofSingular].filter(x => x).join(': '),
      plural: [baseLabel, filter[filter.type].ofPlural].filter(x => x).join(': '),
      label: thisLabelPath,
      // sublabel: filter.sublabel,
      ...parameters,
    };
    return { path: thisFieldPath, component };
  }
  if (filter.type === 'form') {
    return (filter[filter.type].of || []).map(filter => constructChoicesFields(thisFieldPath, thisLabelPath, filter));
  }
  return null;
};

export const digChoicesFromData = async (basePath, data) => {
  const items = data?.contents?.items;

  if (!items) {
    console.error('Error: Invalid data structure');
    return {};
  }

  const resolvedItems = await deepResolveOfs(_.cloneDeep(items));
  const allChoices = resolvedItems
    .map(filter => constructChoicesFields(basePath, '', filter))
    .flat()
    .filter(x => x);

  return Object.fromEntries(allChoices.map(choice => [choice.path, choice.component]));
};

export const digItemAttributesFromData = data => {
  const items = data?.contents?.items;

  if (!items) {
    console.error('Error: Invalid data structure');
    return {};
  }

  return items.filter(i => !i.templated).map(i => ({ value: i.field, label: i.label }));
};

const AttributeSet = props => {
  const { query: { name, path } = {}, linked_object = null, controlled = false } = props || { query: {} };

  const filterState = useAttributeSet(name, path, Board.build.language, linked_object, controlled)

  return filterState ? (
    filterState.error ? (
      <Subschema>
        {{
          [s._]: ui`Tip`.of(`${filterState.name} could not be loaded: ${filterState.error}`),
        }}
      </Subschema>
    ) : (
      <Subschema>{[ui`Form`.of(filterState), {}]}</Subschema>
    )
  ) : (
    <Subschema>
      {{
        [s._]: ui`Tip`.of('Loading...'),
      }}
    </Subschema>
  );
};

export default AttributeSet;
